import { render, staticRenderFns } from "./ProductProviderSelect.vue?vue&type=template&id=fe76d4f4"
import script from "./ProductProviderSelect.vue?vue&type=script&lang=js"
export * from "./ProductProviderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports